import { motion } from "framer-motion";

// Generic scroll-into-view reveal used across manifesto chapters.
export const Reveal = ({ children, className = "", delay = 0, y = 28, testid }) => {
  return (
    <motion.div
      className={className}
      data-testid={testid}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
